import { afterNextRender, AfterViewInit, Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperOptions } from 'swiper';
import { SharedModule } from '@shared/shared.module';
import { SliderBgTextSkeletonComponent } from '../../../../skeletons/slider-bg-text-skeleton/slider-bg-text-skeleton.component';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'iho-slider-bg-text',
    standalone: true,
    imports: [CommonModule, SharedModule, SliderBgTextSkeletonComponent,RouterModule],
    templateUrl: './slider-bg-text.component.html',
    styleUrls: ['./slider-bg-text.component.scss'],
})
export class SliderBgTextComponent implements AfterViewInit {
    @Input() sectionTitle = 'دیدنی ترین مقصدهای ایران';
    @Input() dataSource: any;
    resetSwiper = signal(true);
    sliderConfigs!: SwiperOptions;
    showArrowPrev = false;
    showArrowNext = true;
    

    constructor() {
      this.configSlider();
        afterNextRender(() => {
            this.resetSwiper.set(false);
            setTimeout(() => this.resetSwiper.set(true), 0);
        });
    }

    configSlider() {
        this.sliderConfigs = {
            //slidesPerView: 5,
            spaceBetween: 15,
            grabCursor: true,
            //  spaceBetween: 20,
            breakpoints: {
              // when window width is >= 320px
              320: {
                slidesPerView: 'auto',
                spaceBetween: 20,
              },
              // when window width is >= 480px
              480: {
                slidesPerView: 'auto',
                spaceBetween: 30,
              },
              // when window width is >= 640px
              1200: {
                slidesPerView: 'auto',
                spaceBetween: 15,
                //  width:400,
              },
            },
          };
    }
    ngAfterViewInit(): void {
        this.configSlider()
    }


    onSlideChange(ev: any) {
        if (ev[0].activeIndex === 0){
          this.showArrowPrev = false;
          this.showArrowNext = true;
        } else if (ev[0].activeIndex != 0 && ev[0].isEnd == false)
        {
          this.showArrowPrev = true;
          this.showArrowNext = true;
    
        }
        if (ev[0].activeIndex != 0 && ev[0].isEnd == true){
              this.showArrowPrev = true;
              this.showArrowNext = false;
          }
         
      }
}
